document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tabs]').forEach(wrapper => {
    const buttons = wrapper.querySelectorAll('[data-tab]');
    const panels  = wrapper.querySelectorAll('[data-panel]');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;

        buttons.forEach(b => b.classList.remove('is-active'));
        panels.forEach(p => p.hidden = true);

        btn.classList.add('is-active');
        const panel = wrapper.querySelector(`[data-panel="${target}"]`);
        if (panel) panel.hidden = false;
      });
    });

    // Init : cacher tous sauf le premier
    panels.forEach((p, i) => p.hidden = i !== 0);
  });
});